import { render, staticRenderFns } from "./logo-secondary.vue?vue&type=template&id=42eacf72&scoped=true&"
import script from "./logo-secondary.vue?vue&type=script&lang=js&"
export * from "./logo-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eacf72",
  null
  
)

export default component.exports